<template>
  <Modal
    @closeModal="closeModal"
    v-show="showModal"
    :isLoading="isLoading"
    title="Delete Confirmation"
    :okFunction="deleteOrganisation"
  >
    <template v-slot:body>
      <div class="delete-description">Are you sure you want to delete this organisation?</div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import { ADMIN_ORGANISATIONS_GET, ADMIN_ORGANISATION_DELETE } from '@/store/actions/organisation';

  export default {
    name: 'DeleteOrganisationModal',

    components: { Modal },

    props: {
      organisationId: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        showModal: false,
        isLoading: false,
      };
    },

    mounted() {
      this.showModal = true;
    },

    methods: {
      async deleteOrganisation() {
        this.isLoading = true;

        try {
          await this.$store.dispatch(ADMIN_ORGANISATION_DELETE, this.organisationId);
          this.$toasted.global.general_success({
            message: 'Organization removed',
          });
          await this.$store.dispatch(ADMIN_ORGANISATIONS_GET);
          this.$emit('deleted');
          this.closeModal(true);
        } catch (error) {
          this.$toasted.global.general_error({
            message: error?.response?.data?.message || 'Failed to delete the organization',
          });
        }

        this.isLoading = false;
      },

      closeModal() {
        this.showModal = false;
        this.$emit('closeModal');
      },
    },
  };
</script>
